// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__-AGLO","inputWrap":"CustomTip_inputWrap__1A-zT"};